<script setup>
    import { ref } from 'vue'
    // eslint-disable-next-line no-unused-vars
    import { Modal } from 'bootstrap'

    import person_square from 'url:../images/person-square.svg';
    import shield_lock_fill from 'url:../images/shield-lock-fill.svg';

    const TIMEOUT = 150;
    const CANCEL_RESET_MESSAGE = 'Password Not Changed';
    const SUCCESS_RESET_MESSAGE = 'Password Changed Successfully';
    const INVALID_ERROR = 'Invalid Username or Password';

    const error = ref({
      isError: false,
      userField: false,
      passField: false,
      text: '',
    });
    const JSLoad = ref(true);
    const username = ref('');
    const password = ref('');
    const submitting = ref(false);
    const success = ref({
      isSuccess: false,
      text: '',
    });

    const resetError = () => {
      error.value = {
        isError: false,
        userField: false,
        passField: false,
        text: '',
      };
    }

    const resetSuccess = () => {
      success.value = {
        isSuccess: false,
        text: '',
      };
    }

    const resetAll = () => {
      resetError();
      resetSuccess();
      username.value = '';
      password.value = '';
      submitting.value = false;
    }

    const handleLogin = () => {
      const req = new XMLHttpRequest();
      req.open('POST', '/login', true);
      req.timeout = TIMEOUT * 1000;
      req.setRequestHeader('Content-Type', 'application/json');
      req.onreadystatechange = () => {
        if (req.readyState === 4) {
          if (req.status === 200 || req.status === 201) {
            window.location.reload();
            submitting.value = false;
          } else {
            resetAll();
            error.value = {
              isError: true,
              text: INVALID_ERROR,
            };
          }
        }
      };
      const data = {
        username: username.value,
        password: password.value,
      };
      req.send(JSON.stringify(data));
    }

    const submit = () => {
      submitting.value = true;
      resetError();
      resetSuccess();
      if (username.value === '' || password.value === '') {
        error.value.isError = true;
        success.value.isSuccess = false;
        if (username.value === '') {
          error.value.userField = true;
        }
        if (password.value === '') {
          error.value.passField = true;
        }
        submitting.value = false;
      } else {
        handleLogin();
      }
    }

    const checkParam = () => {
        const params = window.location.search;
        if (params.includes('?')) {
            const query = params.split('=');
            if (query[0] === '?success' && query[1] === 'true') {
            success.value.isSuccess = true;
            success.value.text = SUCCESS_RESET_MESSAGE;
            } else if (query[0] === '?success' && query[1] === 'false') {
            error.value.isError = true;
            error.value.text = CANCEL_RESET_MESSAGE;
            }
        }
    }


    if (window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
    resetAll();
    checkParam();
</script>

<template>
    <div :class="{'dShow': JSLoad}" class="container-fluid border rounded-lg border-dark w-25 mt-5 bg-white dNone">
        <div class="row justify-content-center mt-3">
            <h1 class="col col-md-12 text-center">Welcome to Unravel</h1>
        </div>
        <div class="row justify-content-center">
            <h2 class="col col-md-12 text-center">Please Login</h2>
        </div>
        <div class="row justify-content-center">
            <div v-show="error.isError && error.text !== ''">
                <h3 class="col col-md-12 text-center text-danger my-2">
                    {{ error.text }}
                </h3>
            </div>
            <div v-show="success.isSuccess">
                <h3 class="col col-md-12 text-center text-primary my-2">
                    {{ success.text }}
                </h3>
            </div>
            <div v-show="(!error.isError || error.text === '') && !success.isSuccess">
                <h3 class="col col-md-12 my-5"></h3>
            </div>
        </div>
        <form>
            <div class="form-group">
                <div class="input-group mb-4 mt-3">
                    <span class="input-group-text" id="basic-addon1">
                        <img :src="person_square" alt="">
                    </span>
                    <input type="text" class="form-control"
                        :class="{'is-invalid': error.isError && error.userField}" placeholder="Username"
                        v-model="username" v-on:keyup.enter="submit()">
                    <div class="invalid-feedback">
                        Please provide a username.
                    </div>
                </div>
                <div class="input-group my-4">
                    <span class="input-group-text" id="basic-addon1">
                        <img :src="shield_lock_fill" alt="">
                    </span>
                    <input type="password" class="form-control"
                        :class="{'is-invalid': error.isError && error.passField}" placeholder="Password"
                        v-model="password" v-on:keyup.enter="submit()">
                    <div class="invalid-feedback">
                        Please provide a password.
                    </div>
                </div>
                <p class="text-center text-muted" data-bs-toggle="modal" data-bs-target="#forgotModal"
                    style="cursor: pointer">
                    Forgot Password? Click Here
                </p>
            </div>
        </form>
        <div class="d-flex justify-content-center">
            <button class="btn btn-primary mt-2 mb-4" type="button" :disabled="submitting" @click="submit">
                Login
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    :hidden="!submitting">
                </span>
            </button>
        </div>
    </div>
</template>
